import CornerRibbon from './CornerRibbon'
import cornerRibbonContainer from './cornerRibbonContainer'

export default cornerRibbonContainer(CornerRibbon)
